import { css } from '@emotion/react'

export const flag = css`
  display: inline-block;
  overflow: hidden;
  border-radius: 2px;
  line-height: 0;
  vertical-align: top;
`
